import React, { ReactElement, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { Page } from 'components/common'

import Header from 'components/Header'

interface WrapperProps {
    readonly instrumentType?: InstrumentTypes
    readonly showHeader?: boolean
    readonly showShimmer?: boolean
    readonly shimmer?: ReactElement
    readonly className?: string
    readonly children: ReactNode
}

const Wrapper = ({
    instrumentType,
    showHeader = true,
    children,
    showShimmer,
    className,
    shimmer: Shimmer,
}: WrapperProps): ReactElement => {
    return (
        <Page background="bg-neutral-500" data-testid="wrapper-page">
            <Page.Container data-testid="wrapper-container">
                {showHeader && (
                    <>
                        <Header
                            instrumentType={instrumentType}
                            data-testid="wrapper-header"
                        />
                        <hr
                            data-testid="wrapper-line"
                            className="border-t border-neutral-300"
                        />
                    </>
                )}
                <div
                    data-testid="wrapper-content"
                    className={twMerge(
                        'pt-10 px-6 pb-4 relative flex flex-col flex-1 overflow-hidden',
                        className
                    )}
                >
                    {children}
                </div>
                {showShimmer && Shimmer ? Shimmer : null}
            </Page.Container>
        </Page>
    )
}

export default Wrapper
